module.exports = __webpack_public_path__ + "media/img/welurowa@2x-8bad76a2.png";